import { Facet, Event, getTagTypeName, isMatchingLocation } from '../../FilterList/scripts/product-facets';
import { isEmptyFilterValue, getProductValue } from '../../FilterList/scripts/filter-utils';
import '../../FilterList/scripts/view';
import './sticky-sidebar';

( function() {
	'use strict';

	const emit = ( element, eventName, detail = {} ) => {
		element.dispatchEvent( new CustomEvent( eventName, { detail } ) );
	};

	function initListingView() {
		const listings = Array.from( document.querySelectorAll( '[data-module="listing"]' ) );
		const itemsWithCards = new Set();

		window.colibri = window.colibri || {};
		window.colibri.activeFilters = window.colibri.activeFilters || {};
		window.colibri.data = window.colibri.data || {};

		if ( listings.length === 0 ) {
			return;
		}

		const reindexCards = () => {
			itemsWithCards.clear();
			listings.forEach( ( listing ) => {
				listing.querySelectorAll( '.card[data-item-id]' ).forEach( ( card ) => {
					itemsWithCards.add( Number( card.getAttribute( 'data-item-id' ) ) );
				} );
			} );
		};

		setTimeout( () => {
			reindexCards();

			listings.forEach( ( listing ) => {
				const listingId = listing.dataset.id;
				const filterList = listing.querySelector( '.filter-list' );
				const productLists = Array.from( listing.querySelectorAll( '.product-list-container' ) );

				productLists.forEach( ( productList ) => {
					const counter = productList.querySelector( '.count-results span' );
					if ( counter ) {
						counter.textContent = String( productList.querySelectorAll( '.card' ).length );
					}
				} );

				listing.addEventListener( Event.REQUEST_REINDEX, () => {
					reindexCards();
					emit( listing, Event.ITEMS_CHANGED, {
						activeFilters: window.colibri.activeFilters[ listingId ],
					} );
				} );

				listing.addEventListener( Event.UPDATE_TIMEZONES, () => {
					window.colibri?.utils?.maybeUpdateTimezones?.();
				} );

				if ( !filterList ) {
					return;
				}

				filterList.addEventListener( Event.FILTER_CHANGED, ( event ) => {
					const filters = event.detail || {};
					window.colibri.activeFilters = window.colibri.activeFilters || {};

					if ( typeof filters[ 'reset-filters' ] !== 'undefined' ) {
						window.colibri.activeFilters[ listingId ] = {};
					} else if ( Object.entries( filters ).length > 1 ) {
						if (
							Object.entries( filters ).length === 2 &&
							typeof filters[ Facet.search_phrase ] !== 'undefined' &&
							filters[ Facet.search_phrase ] === null
						) {
							window.colibri.activeFilters[ listingId ] = window.colibri.activeFilters[ listingId ] || {};
							delete window.colibri.activeFilters[ listingId ][ Facet.search_phrase ];
							delete window.colibri.activeFilters[ listingId ][ Facet.search_phrase_item_ids ];
						} else if (
							Object.entries( filters ).length === 2 &&
							typeof filters[ Facet.search_phrase ] !== 'undefined' &&
							typeof filters[ Facet.search_phrase_item_ids ] !== 'undefined'
						) {
							window.colibri.activeFilters[ listingId ] = window.colibri.activeFilters[ listingId ] || {};
							window.colibri.activeFilters[ listingId ][ Facet.search_phrase ] = filters[ Facet.search_phrase ];
							window.colibri.activeFilters[ listingId ][ Facet.search_phrase_item_ids ] = filters[ Facet.search_phrase_item_ids ];
						} else {
							window.colibri.activeFilters[ listingId ] = filters;
						}
					} else {
						window.colibri.activeFilters[ listingId ] = window.colibri.activeFilters[ listingId ] || {};
						Object.entries( filters ).forEach( ( [ facetName, filterValues ] ) => {
							window.colibri.activeFilters[ listingId ][ facetName ] = filterValues;
						} );
					}

					const activeFilters = window.colibri.activeFilters[ listingId ] || {};
					let matchingItemIds = Object.keys( window.colibri?.index?.products || {} )
						.map( ( pid ) => Number( pid ) )
						.filter( ( pid ) => itemsWithCards.has( pid ) );

					Object.entries( activeFilters ).forEach( ( [ facetName, filterValues ] ) => {
						if ( !matchingItemIds.length || isEmptyFilterValue( filterValues ) ) {
							return;
						}

						switch ( facetName ) {
							case Facet.primary_hours:
							case Facet.secondary_hours:
							case Facet.price:
							case Facet.rating:
							case Facet.start_time:
								filterValues.min = parseFloat( filterValues.min );
								filterValues.max = parseFloat( filterValues.max );
								matchingItemIds = matchingItemIds.filter( ( pid ) => {
									let productValue = getProductValue( pid, facetName );
									if ( productValue && ( facetName === Facet.primary_hours || facetName === Facet.secondary_hours ) ) {
										productValue = productValue[ 0 ];
									}
									if ( productValue === null ) {
										return filterValues.min === 0;
									}
									return productValue >= filterValues.min && productValue <= filterValues.max;
								} );
								break;
							case Facet.location:
								matchingItemIds = matchingItemIds.filter( ( pid ) => isMatchingLocation( window.colibri.index.products[ pid ], filterValues ) );
								break;
							case Facet.search_phrase:
								if ( typeof activeFilters[ Facet.search_phrase_item_ids ] !== 'undefined' ) {
									if ( activeFilters[ Facet.search_phrase_item_ids ].length ) {
										const productIds = activeFilters[ Facet.search_phrase_item_ids ].map( ( value ) => parseInt( value, 10 ) );
										matchingItemIds = matchingItemIds.filter( ( pid ) => productIds.includes( pid ) );
									} else {
										matchingItemIds = [];
									}
								}
								break;
						}
					} );

					const prefilteredItemIds = matchingItemIds;

					Object.entries( activeFilters ).forEach( ( [ facetName, filterValues ] ) => {
						if ( !matchingItemIds.length || isEmptyFilterValue( filterValues ) ) {
							return;
						}

						switch ( facetName ) {
							case Facet.credit_type:
							case Facet.profession_id:
							case Facet.license_type_id:
							case Facet.state_code:
							case Facet.education_type_id:
							case Facet.delivery_method_id:
							case Facet.license_levels:
							case Facet.authors:
							case Facet.instructors:
							case Facet.is_partnership_group_item_required:
							case Facet.tags + '::' + getTagTypeName( facetName ): {
								const facetIds = window.colibri?.index?.facets?.[ facetName ] || {};
								matchingItemIds = matchingItemIds.filter( ( pid ) =>
									filterValues.some( ( value ) => ( value in facetIds ) && facetIds[ value ].includes( pid ) )
								);
								break;
							}
						}
					} );

					const matchingProductsSet = new Set( matchingItemIds );
					let countFilters = 0;
					Object.entries( activeFilters ).forEach( ( [ , filterValues ] ) => {
						if ( !isEmptyFilterValue( filterValues ) ) {
							countFilters++;
						}
					} );

					productLists.forEach( ( productList ) => {
						setTimeout( () => {
							emit( productList, Event.LIST_UPDATE, { countFilters, matchingProductsSet } );
						}, 1 );
					} );

					window.colibri.data.matchingItemIds = window.colibri.data.matchingItemIds || {};
					window.colibri.data.prefilteredItemIds = window.colibri.data.prefilteredItemIds || {};
					window.colibri.data.matchingItemIds[ listingId ] = matchingItemIds;
					window.colibri.data.prefilteredItemIds[ listingId ] = prefilteredItemIds;

					const noResults = listing.querySelector( '.no-results' );
					const firstProductList = productLists[ 0 ];
					// insertBefore requires the reference node to be a direct child of the parent.
					// .product-list-container can be nested, so use firstProductList's parent, not listing.
					if ( noResults && firstProductList?.parentNode ) {
						const insertParent = firstProductList.parentNode;
						const alreadyPlaced =
							noResults.parentNode === insertParent &&
							noResults.nextElementSibling === firstProductList;
						if ( ! alreadyPlaced ) {
							insertParent.insertBefore( noResults, firstProductList );
						}
					}
					if ( noResults ) {
						noResults.classList.toggle( 'd-none', matchingItemIds.length > 0 );
					}

					emit( listing, Event.ITEMS_CHANGED, { activeFilters } );
				} );
			} );
		}, 1 );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initListingView, { once: true } );
	} else {
		initListingView();
	}
} )();
